const getRefundableFromItems = (items = []) => {
  return items
    .flatMap(({ cancellations = [] } = {}) => cancellations)
    .some(({ name = '' } = {}) => name.toLowerCase().includes('free'));
};

export { getRefundableFromItems };
